import { Component, OnInit } from '@angular/core';
import { User } from '../../models/User/user';
import { AppContextService } from '../../services/app-context.service';
import { RouteAuthorizationService } from '../../services/authorization/route-authorization.service';
import { CustomTabItem } from '../../shared-components/custom-tabs/custom-tabs.component';

@Component({
	selector: 'eif-design-system',
	templateUrl: './design-system.component.html',
	styleUrls: ['./design-system.component.scss'],
	standalone: false,
})
export class DesignSystemComponent implements OnInit {
	public loggedUser: User | null = null;
	public activeTabId: string = 'resources-manager';

	public readonly tabs: CustomTabItem[] = [
		{ id: 'resources-manager', label: 'Resources Manager', icon: 'fa-folder-open' },
		{ id: 'faq-manager', label: 'FAQ Manager', icon: 'fa-circle-question' },
		{ id: 'faq-viewer', label: 'FAQ Viewer', icon: 'fa-book-open' },
		{ id: 'form-showcase', label: 'Form Showcase', icon: 'fa-grid-2' },
		{ id: 'form-example', label: 'Form Example', icon: 'fa-file-lines' },
		{ id: 'toaster', label: 'Toaster', icon: 'fa-bell' },
		{ id: 'modals', label: 'Modals', icon: 'fa-window-restore' },
		{ id: 'buttons', label: 'Buttons', icon: 'fa-square' },
		{ id: 'icon-buttons', label: 'Icon Buttons', icon: 'fa-icons' },
		{ id: 'menus', label: 'Menus', icon: 'fa-bars' },
		{ id: 'checkboxes', label: 'Checkboxes', icon: 'fa-square-check' },
		{ id: 'radios', label: 'Radios', icon: 'fa-circle-dot' },
		{ id: 'switches', label: 'Switches', icon: 'fa-toggle-on' },
		{ id: 'selects', label: 'Selects', icon: 'fa-chevron-down' },
		{ id: 'inputs', label: 'Inputs', icon: 'fa-edit' },
		{ id: 'inputs-validation', label: 'Input Validation', icon: 'fa-shield-halved' },
		{ id: 'readonly', label: 'Readonly', icon: 'fa-lock' },
		{ id: 'slider', label: 'Slider', icon: 'fa-sliders' },
		{ id: 'date-pickers', label: 'Date Pickers', icon: 'fa-calendar' },
		{ id: 'custom-tooltip', label: 'Tooltip', icon: 'fa-comment-dots' },
	];

	constructor(
		public appContext: AppContextService,
		private routeAuthorizationService: RouteAuthorizationService
	) {}

	ngOnInit(): void {
		this.appContext.getLoggedUserAsync().subscribe((userResult) => {
			this.loggedUser = userResult.Data;

			if (!this.loggedUser?.IsSystemAdmin) {
				this.routeAuthorizationService.routeOnUnauthorized();
			}
		});
	}

	onTabSelect(tabId: string): void {
		this.activeTabId = tabId;
	}
}
